import appLocaleData from 'react-intl/locale-data/en';

import messages from '../messages/en_US.json';

const Lang = {
    messages: {
        ...messages,
    },
    locale: 'en-US',
    format: 'en_US',
    data: appLocaleData,
};
export default Lang;
